// @flow
export const UPDATE_NETWORK_AVAILABILITY = 'sensors/UPDATE_NETWORK_AVAILABILITY';
export const UPDATE_SERVER_REACHABILITY = 'sensors/UPDATE_SERVER_REACHABILITY';

export function updateNetworkAvailability( isNetworkAvailable ) {
    return {
        type: UPDATE_NETWORK_AVAILABILITY,
        isNetworkAvailable
    };
}

export function updateServerReachability( isServerReachable ) {
    return {
        type: UPDATE_SERVER_REACHABILITY,
        isServerReachable
    };
}

